import { AnimatePresence } from 'framer-motion';
import { Redirect, Route, Switch, useLocation } from 'react-router';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Header from './component/common/Header';
import Auth from './middleware/routemiddleware/Auth';
import Home from './pages/Home';
import Receipe from './pages/Receipe';
import ReceipeDescription from './pages/ReceipeDescription';
import Todo from './pages/Todo';
import Tour from './pages/Tour';
toast.configure()
function App() {
  const location = useLocation();;
  return (
    <div className="App">
      <Header />
      <AnimatePresence>
        <Switch location={location} key={location.key}>
          <Route path='/' exact component={() => <Home />} />
          <Route path='/todo' component={() => <Todo classes="center-align blue white-text" title="Todo List" />} />
          <Auth path='/tour' component={() => <Tour classes="center-align green white-text" title="Tour List" />} />
          <Route path='/receipe' component={() => <Receipe classes="center-align pink white-text" title="Receipe List" />} />
          <Route path='/:name' component={() => <ReceipeDescription />} />
          <Route path='/contact' component={() => <Receipe classes="center-align pink white-text" title="Receipe List" />} />
          <Route path='*' component={() => <Redirect to="/" />} />
        </Switch>
      </AnimatePresence>
    </div>
  );
}

export default App;